import { BCMSDefaultModel, BCMSRecord, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from 'components/ui/UIButton';
import Classes, { Transaction } from 'model';
import React from 'react';
import { SVGAsset } from 'res';
import DisputeTransactionDetailsWidget from '../widgets/DisputeTransactionDetailsWidget';
import "./styles.css";

/**
 * @function DisputeDissatisfiedConfirmView
 * @return {React.Component}
 * @exported true
 * @description The view that shows the dispute transaction confirmation
 */

export default function DisputeDissatisfiedConfirmView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();
  const params = useParams();
  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    next: evt => {
      navigate(`/home/viewalltransactions/purchases/${ params.cardID }/disputeTransactionWorkflow`);
      //goStep(6, { ...data, ...ui });
    },
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, next, cancel, confirm, update, updateTextInput } = useStateManager();
  const dispute = data.dispute ?? {};
  const doneButtonDataPoint = { dataPoint: "Done_Button" };


  return (
    <div className="dispute-dissatisfied-confirm-view">
      <div className="flex-container flex-vertical align-center-container">
        <div className="framed-icon-container">
          <SVGAsset id="CheckmarkIcon" />
        </div>
        <h2>Your dispute has been submitted.</h2>
        <p className="text-center confirmed-dispute-text">Our disputes team will review the information you have provided. It can take up to <span>{ "<10>" } </span>
          business days to receive written confirmation for your claim outlining the next steps, 
          as well as notification of any temporary credit that may be issued.</p>

          <DisputeTransactionDetailsWidget dispute={ dispute } />

          <p className="questions-text">If you have any questions regarding this disputed transaction, call us.</p>
          <UIPrimaryButton text="Done" { ...doneButtonDataPoint } onClick={ next } />
      </div>
    </div>
  );
}